var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4233_15371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58853 0 0 3.58853 0 8C0 12.4115 3.58853 16 8 16C12.4115 16 16 12.4108 16 8C16 3.58916 12.4115 0 8 0ZM8 14.7607C4.27266 14.7607 1.23934 11.728 1.23934 8C1.23934 4.27203 4.27266 1.23934 8 1.23934C11.7273 1.23934 14.7607 4.27203 14.7607 8C14.7607 11.728 11.728 14.7607 8 14.7607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0984 7.32456H8.61967V4.84588C8.61967 4.50381 8.34267 4.22619 7.99998 4.22619C7.6573 4.22619 7.3803 4.50381 7.3803 4.84588V7.32456H4.90161C4.55892 7.32456 4.28192 7.60219 4.28192 7.94425C4.28192 8.28631 4.55892 8.56394 4.90161 8.56394H7.3803V11.0426C7.3803 11.3847 7.6573 11.6623 7.99998 11.6623C8.34267 11.6623 8.61967 11.3847 8.61967 11.0426V8.56394H11.0984C11.441 8.56394 11.718 8.28631 11.718 7.94425C11.718 7.60219 11.441 7.32456 11.0984 7.32456Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4233_15371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.ec92571c1439d54fb0ae04d8b91c6dbf.svg";
export { ForwardRef as ReactComponent };